import { render, staticRenderFns } from "./InvestmentForm.vue?vue&type=template&id=3080c8b8&scoped=true"
import script from "./InvestmentForm.vue?vue&type=script&lang=js"
export * from "./InvestmentForm.vue?vue&type=script&lang=js"
import style0 from "./InvestmentForm.vue?vue&type=style&index=0&id=3080c8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080c8b8",
  null
  
)

export default component.exports